import FormCheckBox from './component.jsx'
export default FormCheckBox
